import * as React from "react";
import { useCallback, useEffect } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import useSearchConfiguration from "hooks/useSearchConfiguration";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useAutoRefresh from "views/hooks/useAutoRefresh";
import useMinimumRefreshInterval from "views/hooks/useMinimumRefreshInterval";
import RefreshControls from "components/common/RefreshControls";
import useDefaultInterval from "views/hooks/useDefaultIntervalForRefresh";
const useDisableOnFormChange = () => {
  const { refreshConfig, stopAutoRefresh } = useAutoRefresh();
  const { dirty, isSubmitting } = useFormikContext();
  useEffect(() => {
    if ((refreshConfig == null ? void 0 : refreshConfig.enabled) && !isSubmitting && dirty) {
      stopAutoRefresh();
    }
  }, [dirty, isSubmitting, refreshConfig == null ? void 0 : refreshConfig.enabled, stopAutoRefresh]);
};
const ViewsRefreshControls = ({ disable = false }) => {
  const { dirty, submitForm } = useFormikContext();
  const sendTelemetry = useSendTelemetry("search-bar");
  const { t } = useTranslation("search");
  const { config } = useSearchConfiguration();
  const autoRefreshTimerangeOptions = config == null ? void 0 : config.auto_refresh_timerange_options;
  const { data: minimumRefreshInterval, isInitialLoading: isLoadingMinimumInterval } = useMinimumRefreshInterval();
  const defaultInterval = useDefaultInterval();
  useDisableOnFormChange();
  const onSelectInterval = useCallback(
    (interval) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_REFRESH_CONTROL_PRESET_SELECTED, {
        app_action_value: "refresh-search-control-dropdown",
        event_details: { interval }
      });
      if (dirty) {
        submitForm();
      }
    },
    [dirty, sendTelemetry, submitForm]
  );
  const onToggle = useCallback(
    (enabled) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_REFRESH_CONTROL_TOGGLED, {
        app_pathname: "search",
        app_action_value: "refresh-search-control-enable",
        event_details: { enabled }
      });
    },
    [sendTelemetry]
  );
  if (!config) {
    return null;
  }
  const intervalOptions = Object.entries(autoRefreshTimerangeOptions);
  return /* @__PURE__ */ React.createElement(
    RefreshControls,
    {
      disable,
      intervalOptions,
      isLoadingMinimumInterval,
      minimumRefreshInterval,
      defaultInterval,
      humanName: t("search_bar.refresh_human_name"),
      onToggle,
      onEnable: submitForm,
      onSelectInterval
    }
  );
};
export default ViewsRefreshControls;
